import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { apiWrapper } from "../../../api/apiWrapper";
import { IBaseResponeModel } from '../../../models/response/base-response';
import { actions } from '../../actions/actionsWrapper';
import { eNgayNghiActionTypeIds, INgayNghiActionTypes } from '../../action-types/danh-muc/INgayNghiActionTypes';
import { INgayNghi } from '../../../models/response/category/INgayNghi';


export function* ngayNghiSaga(): any {
    yield takeLatest(eNgayNghiActionTypeIds.LOAD_START, loadWorker)
    yield takeLatest(eNgayNghiActionTypeIds.LOAD_COSO_START, loadByCosoWorker)
    yield takeEvery(eNgayNghiActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eNgayNghiActionTypeIds.DELETE_START, deleteWorker)


}

function* loadWorker(): any {
    const res: IBaseResponeModel = yield call(apiWrapper.ngayNghi.select_all)
    if (res.is_success) {
        yield put(actions.danhMucWrapper.ngayNghi.LOAD_SUCCESS(res.data))
    } else {
        yield put(actions.danhMucWrapper.ngayNghi.LOAD_ERROR(res.message ?? "Error"))
    }
}

function* loadByCosoWorker(action: INgayNghiActionTypes): any {
    const payload: number = action.payload as number;
    const res: IBaseResponeModel = yield call(apiWrapper.ngayNghi.select_by_coso, payload)
    if (res.is_success) {
        yield put(actions.danhMucWrapper.ngayNghi.LOAD_COSO_SUCCESS(res.data))
    } else {
        yield put(actions.danhMucWrapper.ngayNghi.LOAD_COSO_ERROR(res.message ?? "Error"))
    }
}

function* saveWorker(action: INgayNghiActionTypes): any {
    const payload: INgayNghi = action.payload as INgayNghi;
    let res: IBaseResponeModel;
    if (payload.id > 0) {
        res = yield call(apiWrapper.ngayNghi.update, payload)
    } else {
        res = yield call(apiWrapper.ngayNghi.insert, payload)
    }
    if (res.is_success) {
        yield put(actions.danhMucWrapper.ngayNghi.SAVE_SUCCESS(res.data))
    } else {
        yield put(actions.danhMucWrapper.ngayNghi.SAVE_ERROR(res.message ?? "Error"))
    }
}

function* deleteWorker(action: INgayNghiActionTypes): any {
    const payload: number = action.payload as number;
    const res: IBaseResponeModel = yield call(apiWrapper.ngayNghi.delete, payload)
    if (res.is_success) {
        yield put(actions.danhMucWrapper.ngayNghi.DELETE_SUCCESS(undefined))
    } else {
        yield put(actions.danhMucWrapper.ngayNghi.DELETE_ERROR(res.message ?? "Error"))
    }
}